import { TextStyle } from 'pixi.js';
import { addResizeListener } from 'game/core/display';
import { Layout } from 'game/LayoutManager';
import { Displays } from 'constants/layout';
const baseFontStyle = {
    textBaseline: 'bottom',
    fontFamily: 'Inter',
    fill: '#ffffff',
};
const titleStyle = new TextStyle({
    ...baseFontStyle,
    align: 'left',
    fontSize: 22,
});

const difficultyStyle = new TextStyle({
    ...baseFontStyle,
    align: 'center',
    fontSize: 19,
});
const autocompleteStyle = new TextStyle({
    ...baseFontStyle,
    align: 'center',
    fontSize: 19,
});

const valueStyle = new TextStyle({
    ...baseFontStyle,
    align: 'center',
    fontSize: 24,
});

const labelStyle = new TextStyle({
    ...baseFontStyle,
    align: 'center',
});

const settingLabelStyle = new TextStyle({
    ...baseFontStyle,
    align: 'left',
    fontSize: 16,
});

const changeStyle = function () {
    const device = Layout.getDisplay();
    switch (device) {
        case Displays.DESKTOP:
            valueStyle.fontSize = 24;
            labelStyle.fontSize = 14;
            difficultyStyle.fontSize = 19;
            break;
        case Displays.TABLET:
            valueStyle.fontSize = 18;
            labelStyle.fontSize = 12;
            difficultyStyle.fontSize = 19;
            break;
        case Displays.MOBILE:
            valueStyle.fontSize = 12;
            labelStyle.fontSize = 10;
            difficultyStyle.fontSize = 12;
            break;
    }
};

addResizeListener(changeStyle, 'changeFileStyle');

export { valueStyle, labelStyle, settingLabelStyle, titleStyle, difficultyStyle, autocompleteStyle };
